import {
  Skeleton,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import React from 'react';
import { IOSSwitch } from './UnlockTherapist';
import { Box } from '@mui/system';
import { useSelector } from 'react-redux';

type Props = {
  item: any;
  handleChangeSwitch: any;
};

const UnlockTherapistTable = (props: Props) => {
  const { item = [], handleChangeSwitch } = props;
  const getAllUnlockTherapist = useSelector((state: any) => state?.getUnlockTherapistReducer);

  return (
    <>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>#</TableCell>
            <TableCell>Patient Name</TableCell>
            <TableCell>Therapist Name</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {getAllUnlockTherapist?.loading ? (
            <>
              {['1', '2', '3'].map((res) => {
                return (
                  <TableRow key={res}>
                    {['1', '2', '3'].map((sle) => {
                      return (
                        <TableCell key={sle}>
                          <Box
                            sx={{
                              width: '100%',
                              display: 'flex',
                              justifyContent: 'space-between',
                            }}
                            key={sle}
                          >
                            <Typography
                              width={'100%'}
                              variant="h1"
                            >
                              <Skeleton animation={false} />
                            </Typography>
                          </Box>
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
            </>
          ) : item?.length === 0 ? (
            <TableRow>
              <TableCell colSpan={5}>
                <Box
                  textAlign="center"
                  p={3}
                >
                  <Typography
                    color={'text.secondary'}
                    variant="subtitle2"
                  >
                    No Records Found
                  </Typography>
                </Box>
              </TableCell>
            </TableRow>
          ) : (
            item?.map((res: any, index: number) => (
              <TableRow key={index}>
                <TableCell>{index + 1}</TableCell>
                <TableCell>{res?.patientName}</TableCell>
                <TableCell>{res?.providerName}</TableCell>
                <TableCell>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <IOSSwitch
                      onChange={(e) => handleChangeSwitch(e, res)}
                      checked={res?.locked}
                    />
                    {res?.locked ? 'Locked' : 'Unlocked'}
                  </Box>
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </>
  );
};

export default UnlockTherapistTable;
